import { useMemo } from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import SeniorenplatformItem from "../SeniorenplatformItem/SeniorenplatformItem"
import { SeniorenplatformAccountPopup }  from "../SeniorenplatformLoginPopup/SeniorenplatformAccount";
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import { Loading } from "../../FicheLijst/Loading/Loading";

export const SeniorenplatformRelevantLeveledExercisesExternal = (props) => {

    const [accountPopup, toggleAccountPopup] = useState(false);
    const [relativeExercises, setRelativeExercises] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        if (props.folderId) {
            fetch(`/umbraco/api/seniorenplatform/GetRelevantLeveledExercises?poId=${props.poId}&folderId=${props.parentFolderId}&exerciseGroup=${props.exerciseGroup}`)
                .then(response => {
                    var data = response.json();
                    data.then(data => {
                        setRelativeExercises(data);
                        setIsLoading(false);
                        data.length === 0 ? this.props.updateShowLeveledExercisesComponent(false) : '';
                    }).catch(error => {
                        console.log(error);
                        setRelativeExercises(null);
                        setIsLoading(false);
                    });
                })
                .catch(() => {
                    console.error("Error while fetching data");
                    setRelativeExercises(null);
                    setIsLoading(false);
                });
        }
    }, [props.folderId, props.id])

    //Add item to favorites
  function addToFavorites(entry) {
    setIsLoading(true);

    const id = entry.id;
    const omschrijving = entry.name;
    const newRelativeExercises = relativeExercises.map(e => e.id == id ? { ...e, isFavorite: true } : e);
    setRelativeExercises(newRelativeExercises);
    axios
      .get(
        `/umbraco/api/seniorenplatform/addtofavorites?poId=${props.poId}&id=${id}&name=${omschrijving}`
      )
      .then((response) => {
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      }
      );
  }

  //Remove item from favorites
  function removeFromFavorites(entry) {
    setIsLoading(true);

    const id = entry.id;
    const omschrijving = entry.name;
    const newRelativeExercises = relativeExercises.map(e => e.id == id ? { ...e, isFavorite: false } : e);
    setRelativeExercises(newRelativeExercises);
    axios
      .get(
        `/umbraco/api/seniorenplatform/removefromfavorites?poId=${props.poId}&id=${id}&name=${omschrijving}`
      )
      .then((response) => {
        setIsLoading(false);
      }
      )
      .catch((err) => {
        console.log(err);
      }
      );
  }

  //Toggle item in favorites
  function toggleIsFavorites(entry) {
    if (props.poId && props.poId !== "") {
        if (entry.isFavorite) {
          removeFromFavorites(entry);
        } 
        else {
          addToFavorites(entry);
        }      
    }
    else {
      //Show account popup
      toggleAccountPopup(true);
    }
  }

    const relevantCards = useMemo(() => {
        if (relativeExercises) {
            return relativeExercises.map((exercise, index) => {               
                if (exercise) {
                    return <SeniorenplatformItem
                        item={exercise}
                        key={index}
                        dictionary={props.dictionary}
                        toggleIsFavorites={toggleIsFavorites}
                        getDetailsOfItem={props.getDetailsOfItem}
                        isExternal={true}
                        isTechnicalExercise={true}
                        exerciseLocation={props.parentFolderUrl} />
                }
            }
            );
        }
    }, [JSON.stringify(relativeExercises)]);


   

    const relevantSliderItems = useMemo(() => {
        if (relativeExercises) {
            return relativeExercises.map((exercise, index) => {                
                if (exercise) {
                    return <SwiperSlide key={index}>
                              <SeniorenplatformItem
                                  item={exercise}
                                  key={index}
                                  dictionary={props.dictionary}
                                  toggleIsFavorites={toggleIsFavorites}
                                  getDetailsOfItem={props.getDetailsOfItem}
                                  isExternal={true}
                                  isTechnicalExercise={true}
                                  exerciseLocation={props.parentFolderUrl} />
                            </SwiperSlide>
                }
              }
            )
        }
    }, [JSON.stringify(relativeExercises)]);

    return (
      relevantCards ? (
        !isLoading ? <>
          <div className="c-senioren__detail__exercises c-senioren__detail__technical-exercises c-senioren__detail__exercises--external">        
              <h3>
                  {props.dictionary.technicalExercise}
              </h3>
              <div className="c-senioren__detail__exercises__swiper">
                  <Swiper
                      spaceBetween={50}
                      slidesPerView={1.5}
                  >
                      {relevantSliderItems}
                  </Swiper>
              </div>
              <div className="c-senioren__detail__exercises__items">
                  {relevantCards}
              </div>
          </div>
          {
              accountPopup ? <SeniorenplatformAccountPopup
              dictionary={props.dictionary}
              loginUrl={props.loginUrl}
              registerUrl={props.registerUrl}
              closePopup={() => toggleAccountPopup(false)} />
              : null
          }
        </>  
        : <Loading/>   
      )
      : null
    )
}